import type { Enrollment } from "sj-ui-toolkit/src/api/userEnrollments";

import { LevelPaths } from "./LevelPaths";
import { QuestBucket } from "./QuestBucket";

interface BucketOfLearninsProps {
  currentPaths?: Enrollment[];
  currentQuests?: Enrollment[];
  hasOutstandingStrictAssignment?: boolean;
}

export const BucketOfLearnins = ({
  currentPaths = [],
  currentQuests = [],
  hasOutstandingStrictAssignment = false,
}: BucketOfLearninsProps) => {
  if (hasOutstandingStrictAssignment) {
    return null;
  }

  return (
    <>
      <QuestBucket currentQuests={currentQuests} />
      <LevelPaths currentPaths={currentPaths} />
    </>
  );
};
